/**Import des modules néccessaires */
import Axios from "../caller.services";

let getAllBeds = () => {
    return Axios.get("/beds");
};

let getBed = (uuid) => {
    return Axios.get("/beds/" + uuid);
};

let addBed = (data) => {
    return Axios.post("/beds", data);
};

let updateBed = (bed) => {
    return Axios.put("/beds/" + bed.uuid, bed);
};

let deleteBed = (uuid) => {
    return Axios.delete("/beds/" + uuid);
};

export const bedService = {
    getAllBeds,
    getBed,
    addBed,
    updateBed,
    deleteBed,
};